import React from 'react'
import { render } from 'react-dom'

import { SweetAlert } from '_zari/core'

const showAlert = ({ tipo, mensaje, onSuccess, showCerrar, onClose }) => {
  let containerDomNode = document.getElementById('zr-sweet-alert-container')
  if (containerDomNode) {
    containerDomNode.parentNode.removeChild(containerDomNode)
  }
  let nuevoContainerDomNode = document.createElement('div')
  nuevoContainerDomNode.id = 'zr-sweet-alert-container'
  nuevoContainerDomNode.className = 'zr-popalert__wrapper open'
  document.body.appendChild(nuevoContainerDomNode)

  render(
    <SweetAlert
      tipo={tipo}
      mensaje={mensaje}
      onSuccess={onSuccess}
      showCerrar={showCerrar}
      onClose={onClose}
    />,
    nuevoContainerDomNode
  )
}

export default Object.freeze({
  showAlert
})
